import React, {useState} from "react";
import {login} from "./bigtimeService";
// import {createHashHistory} from 'history';
import {useNavigate} from 'react-router-dom';

function BigtimeLoginForm() {
	const navigate = useNavigate();
	const [inputs, setInputs] = useState({});
	// const history = createHashHistory();

	const handleChange = event => {
		const name = event.target.name;
		const value = event.target.value;
		setInputs(values => ({...values, [name]: value}));
		console.log("handleChange", inputs);
	}

	const handleSubmit = event => {
		event.preventDefault();
		console.log("handleSubmit", inputs); 
		login(inputs.bigtimeUsername, inputs.bigtimePassword).then(
			data => {
				console.log('data', data);
				window.localStorage.setItem('bigtime-token', data.token);
				navigate('/week', {replace: true});
				// history.back();
			},
			error => {
				console.error('error object', error);
			}
		);
	}

	window.localStorage.removeItem('bigtime-token');
	return (
		<>
		<form name="bigtime-login" onSubmit={handleSubmit}>
			<h1>Bigtime Login</h1>
			<table>
			<tbody>
			<tr>
				<td><label htmlFor="bigtimeUsername">Name:</label></td>
				<td>
				<input type="text" name="bigtimeUsername" id="bigtimeUsername"
					value={inputs.bigtimeUsername || ""}
					onChange={handleChange} />
				</td>
			</tr>
			<tr>
				<td><label htmlFor="bigtimePassword">Password:</label></td>
				<td>
				<input type="password" name="bigtimePassword" id="bigtimePassword"
					value={inputs.bigtimePassword || ""}
					onChange={handleChange} />
				</td>
			</tr>
			</tbody>
			</table>
			<input type="submit"/>
		</form>
		</>
	)
}

export default BigtimeLoginForm;